import z from "zod";

import { zAttrComponent } from "./attrEdits/ZAttrComponent";
import { zAttrRule } from "./ZAttrRule";

const zAttrColSpan = z.number().or(z.literal("*")).nullish();
export type ZAttrColSpan = z.infer<typeof zAttrColSpan>;

const zAttrNewLine = z.boolean().nullish();
export type ZAttrNewLine = z.infer<typeof zAttrNewLine>;

export const zAttrEdit = z.object({
  order: z
    .number()
    .nullish()
    .describe("Числовое значение, определяющее порядок атрибутов"),
  title: z.string().nullish().describe("Для переопределения AttrMeta.title"),
  tooltip: z.string().nullish().describe("Текст подсказки"),
  colSpan: zAttrColSpan.describe(
    "Количество занимаемых колонок в сетке. *=все",
  ),
  rowSpan: z.number().nullish().describe("Количество занимаемых строк в сетке"),
  newLine: zAttrNewLine.describe("Располагать в сетке с новой строки"),
  component: zAttrComponent.nullish().describe("Компонент для редактирования"),
  rules: zAttrRule.array().nullish().describe("Правила валидации"),
});

export type ZAttrEdit = z.infer<typeof zAttrEdit>;
